import { runningAsApp } from "./runningAsApp";

export function offlineAvailable(): boolean {
  return runningAsApp() && "serviceWorker" in navigator;
}

/** Offline support is only for the installed app, so a browser visit stays an ordinary page. */
export function startAppWorker(portraitBase: string | undefined): void {
  if (!import.meta.env.PROD || !offlineAvailable()) {
    return;
  }
  const origin = portraitBase === undefined || portraitBase === "" ? "" : new URL(portraitBase).origin;
  const query = origin === "" ? "" : `?portraits=${encodeURIComponent(origin)}`;
  void navigator.serviceWorker.register(`/sw.js${query}`).catch(() => undefined);
}
